import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import {
  faGithub,
  faLinkedin,
  faMedium,
  faStackOverflow,
} from "@fortawesome/free-brands-svg-icons";
import { Box, HStack } from "@chakra-ui/react";

const socials = [
  {
    icon: faEnvelope,
    url: "mailto:phomolontokoane32@gmail.com",
  },
  {
    icon: faGithub,
    url: "https://github.com/phomolontokoane",
  },
  {
    icon: faLinkedin,
    url: "https://www.linkedin.com/in/phomolo-ntokoane-ab8a7b1a7",
  },
  {
    icon: faMedium,
    url: "https://medium.com",
  },
  {
    icon: faStackOverflow,
    url: "https://stackoverflow.com",
  },
];

const links = [
  { path: "projects", text: "Projects" },
  { path: "contact-me", text: "Contact Me" },
];

const Header = () => {
  const handleClick = (anchor) => () => {
    console.log("Hello")
    const id = `${anchor}-section`;
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const previousScroll = useRef(0)
  const [translateY, setTranslateY] = useState(0)

  useEffect(() => {
    const handleScroll = (e) => {
      const y = e.clientY
      if (y > previousScroll.current) {
        setTranslateY(-200);
      } else {
        setTranslateY(0)
      }
      previousScroll.current = y;
    }

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      translateY={0}
      transitionProperty="transform"
      transitionDuration=".3s"
      transitionTimingFunction="ease-in-out"
      backgroundColor="#18181b"
      style={{}}
    >
      <Box color="white" maxWidth="1280px" margin="0 auto">
        <HStack
          px={16}
          py={4}
          justifyContent="space-between"
          alignItems="center"
        >
          <nav>
            <HStack justifyContent={"space-between"} alignItems={"center"} spacing={6}>
              {socials.map(({ url, icon }) => (
                <a href={url} key={url}>
                  <FontAwesomeIcon icon={icon} size="2x" />
                </a>
              ))}
            </HStack>
          </nav>
          <nav>
            <HStack spacing={8}>
              {links.map(({ path, text }) => (
                <a
                  href={`/#${path}`}
                  key={path}
                  onClick={() => handleClick(path)}
                >
                  {text}
                </a>
              ))}
            </HStack>
          </nav>
        </HStack>
      </Box>
    </Box>
  );
};
export default Header;
